import { Component, Input, InputSignal, computed, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TiimePipesModule } from 'tiime-expert-utils';
import { TiimeButtonModule, TiimeIconModule, TiimeTableModule, TiimeTooltipModule } from 'tiime-material';

import { GiFilesFormTableBase } from '@bases/gi-files-form-table/gi-files-form-table.base';
import { GIFileType } from '@enums/gi-file-type.enum';
import { GIFileForm } from '@forms/gi-file-form';
import { ContractStatus } from '@gi/enums/contract-status.enum';
import { SimpleCellComponent } from '@shared-cells/simple-cell/simple-cell.component';
import { CodeAndLabelPipe } from '@shared-pipes/code-and-label/code-and-label.pipe';

@Component({
  selector: 'app-contract-files-form-table',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeButtonModule,
    TiimeIconModule,
    TiimeTableModule,
    TiimeTooltipModule,
    TiimePipesModule,
    SimpleCellComponent,
    CodeAndLabelPipe
  ],
  templateUrl: './contract-files-form-table.component.html',
  styleUrls: ['./contract-files-form-table.component.scss']
})
export class ContractFilesFormTableComponent extends GiFilesFormTableBase<GIFileType, number> {
  @Input({ required: true }) filesForms: GIFileForm[];

  readonly contractStatus: InputSignal<ContractStatus> = input.required<ContractStatus>();
  readonly sentLastSignatureIcon = computed(() =>
    this.contractStatus() === ContractStatus.signed ? 'mark_email_read' : 'attach_email'
  );
  readonly sentLastSignatureTooltip = computed(() =>
    this.contractStatus() === ContractStatus.signed
      ? 'Document validé par le client lors de la signature du contrat.'
      : 'Document envoyé pour validation par le client.'
  );
  readonly ContractStatus: typeof ContractStatus = ContractStatus;
}
